module.exports = {
	message: {
		title: 'English'
	},
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js